import {
  IHttpApi,
  mergeBaseUri,
  mergePaths,
  transformObjectToQuery,
  IHTTPRequestConfig,
  IHTTPCompletedResponse,
} from '@cian/http-api';

import { IRemoveCommentRequest, IRemoveCommentConfig, TResponses } from './types';

const defaultConfig: Required<IRemoveCommentConfig> = {
  pathApi: '/v1/delete-comment',
  browserUrl: 'http://www.master.dev3.cian.ru/content-api',
};

export const defaultRequest: IHTTPRequestConfig = {
  uri: {
    host: '',
    path: '',
  },
  method: 'POST',
  requestType: 'formData',
  body: '',
  withCredentials: true,
  responseType: 'json',
  headers: [['Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8']],
};

function createRemoveCommentRequest({
  bodyParameters,
  queryParameters,
  config,
}: Pick<IRemoveCommentOptions, 'bodyParameters' | 'queryParameters' | 'config'>): IHTTPRequestConfig {
  const { pathApi, browserUrl } = { ...defaultConfig, ...config };

  return {
    ...defaultRequest,
    uri: mergeBaseUri(browserUrl, {
      path: (path: string) => mergePaths(path, pathApi),
      query: transformObjectToQuery(queryParameters),
    }),
    body: transformObjectToQuery(bodyParameters),
  };
}

export interface IRemoveCommentOptions {
  httpApi: IHttpApi;
  bodyParameters: IRemoveCommentRequest;
  queryParameters?: IRemoveCommentRequest;
  config?: IRemoveCommentConfig;
}

async function requestRemoveComment({
  httpApi,
  bodyParameters,
  queryParameters,
  config,
}: IRemoveCommentOptions): Promise<IHTTPCompletedResponse<TResponses>> {
  return httpApi.httpRequest(createRemoveCommentRequest({ bodyParameters, queryParameters, config }));
}

export { defaultConfig, createRemoveCommentRequest, requestRemoveComment };
